import {Object3D, TextComponent} from '@wonderlandengine/api';
import {useRef, useState} from 'react';
import {WLUtils} from '../../utils/WLUtils.js';

/**
 * Updates the text on a reference, without triggerion a re-render. It doesn't
 * actually use a state.
 */
export function useTextState(
    initialState: (() => string) | string
): [string, (text: string) => void, React.RefObject<Object3D>] {
    initialState = typeof initialState === 'function' ? initialState() : initialState;
    const ref = useRef<Object3D>(null);
    const updateText = (text: string) => {
        if (ref.current) {
            const tc = WLUtils.getComponentsOfTypeRecursive(ref.current, TextComponent)[0];
            if (tc) {
                tc.text = text;
            }
        }
    };

    updateText(initialState);
    return [initialState, updateText, ref];
}
